import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../config/Api";
import { Seller, SellerReq, UpdateSellerReq } from "../../types/sellerType";

import { authSlice, logout } from './../AuthSlice';
import { AxiosError } from "axios";


export const fetchSellerProfile=createAsyncThunk<Seller>("/seller/fetchSellerProfile",
    async(_,{rejectWithValue})=>{
        try {
            const response = await api.get("/sellers/profile",{
            })
            
            return response.data
        } catch (error:any) {
            return rejectWithValue(error.response?.data?.message||'Signup Failed')
        }
    }
)
export const updateSellerAccount=createAsyncThunk<Seller,UpdateSellerReq>("/seller/updateSellerAccount",
    async(seller,{rejectWithValue})=>{
        try {
            
            const response = await api.patch("/sellers/update",seller)
           
            return response.data
        } catch (error:any) {
           
            return rejectWithValue(error.response?.data?.message||'Signup Failed')
        }
    }
)
export const getSellerById=createAsyncThunk<Seller,number>("/seller/getSellerById",
    async(id:number,{rejectWithValue})=>{
        try {
            const response = await api.get(`/sellers/${id}`,{
            })
          
            return response.data
        } catch (error:any) {
            return rejectWithValue(error.response?.data?.message||'Signup Failed')
        }
    }
)
export const createAccountSeller = createAsyncThunk<Seller,SellerReq>("/seller/createAccountSeller",
    async(req,{rejectWithValue})=>{
        try {
            const response = await api.post("/sellers/create",req)
           
            return response.data
        } catch (error:any) {
            
           return rejectWithValue(error.response?.data?.message||'Signup Failed')
        }
    }
)
export const verifySeller = createAsyncThunk<Seller,string>("/seller/verify",
    async(otp,{rejectWithValue})=>{
        try {
            console.log("I am calling");
            const response = await api.get(`/sellers/verify/${otp}`)
           console.log(response.data);
            return response.data
        } catch (error:any) {
            console.log("error: ",error);
           return rejectWithValue(error.response?.data?.message||'Signup Failed')
        }
    }
)

interface LoginRequest {
    email: string;
    otp: string;
  }
  
export const signInSeller=createAsyncThunk<any,LoginRequest>("/sellers/signIn",
    async(loginRequest,{rejectWithValue})=>{
        try {
            const response = await api.post("/sellers/login",loginRequest)
            return response.data
        } catch (error) {
           console.error("Error: ",error); 
        }
    }
)
interface SellerState{
    isVerify:boolean
    sellers: any[],
    selectedSeller:any,
    seller:Seller|null,
    profile:Seller|null,
    report:any,
    loading:boolean,
    error:any,
    otp:boolean
}
 const initialState:SellerState={
    isVerify:false,
    sellers:[],
    seller:null,
    selectedSeller:null,
    profile:null,
    report:null,
    loading:false,
    error:null,
    otp:false,
    
}

export const sellerSlice=createSlice({
    name:"seller",
    initialState,
    reducers:{},
    extraReducers:(builder) => { 
        // one user make a request then the state will be pending once data is come the state fulfill request is filled
        builder.addCase(fetchSellerProfile.pending,(state)=>{
            state.loading=true;
        })
        .addCase(fetchSellerProfile.fulfilled,(state,action:PayloadAction<Seller>)=>{
            state.loading=false;
            state.profile=action.payload
        })
        .addCase(fetchSellerProfile.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })
        .addCase(updateSellerAccount.pending,(state)=>{
            state.loading=true;
        })
        .addCase(updateSellerAccount.fulfilled,(state,action:PayloadAction<Seller>)=>{
            state.loading=false;
            state.profile=action.payload
        })
        .addCase(updateSellerAccount.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })
        .addCase(getSellerById.pending,(state)=>{
            state.loading=true;
        })
        .addCase(getSellerById.fulfilled,(state,action:PayloadAction<Seller>)=>{
            state.loading=false;
            state.seller=action.payload
        })
        .addCase(getSellerById.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })
        // create seller
        .addCase(createAccountSeller.pending,(state)=>{
            state.loading=true;
        })
        .addCase(createAccountSeller.fulfilled,(state,action:PayloadAction<Seller>)=>{
            state.loading=false;
            state.profile=action.payload
           
        })
        .addCase(createAccountSeller.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

        // loginSeller

        .addCase(signInSeller.pending,(state)=>{
            state.loading=true;
        })
        .addCase(signInSeller.fulfilled,(state,action:PayloadAction<Seller>)=>{
            state.loading=false;
            state.profile=action.payload
            
        })
        .addCase(signInSeller.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

        .addCase(verifySeller.pending,(state)=>{
            state.loading=true;
        })
        .addCase(verifySeller.fulfilled,(state,action:PayloadAction<Seller>)=>{
            state.loading=false;
            state.profile=action.payload
            state.isVerify= true
            
        })
        .addCase(verifySeller.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload
        })

        // logout
        .addCase(logout.fulfilled, (state) => {
            state.profile = null;  // Reset the seller profile
          });
     }
})

export const sellerReducer = sellerSlice.reducer;